import { useState } from 'react';

import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/shared/ui/shadcn/tabs';

import { PendingRefillsList } from './PendingRefillsList';
import { PendingRxChangesList } from './PendingRxChangesList';

type WorklistTab = 'refills' | 'rxChanges';

export interface DoseSpotWorklistsProps {
  readonly patientId?: number | null;
}

/** Read-only tab shell for pending refills and pending RxChanges. */
export function DoseSpotWorklists({ patientId }: DoseSpotWorklistsProps) {
  const [activeTab, setActiveTab] = useState<WorklistTab>('refills');

  return (
    <div className="flex flex-col gap-3">
      <Tabs
        value={activeTab}
        onValueChange={(next) => setActiveTab(next === 'rxChanges' ? 'rxChanges' : 'refills')}
      >
        <TabsList aria-label="DoseSpot worklists">
          <TabsTrigger value="refills">Refills</TabsTrigger>
          <TabsTrigger value="rxChanges">RxChanges</TabsTrigger>
        </TabsList>

        <TabsContent value="refills" className="mt-2">
          <PendingRefillsList patientId={patientId} />
        </TabsContent>
        <TabsContent value="rxChanges" className="mt-2">
          <PendingRxChangesList patientId={patientId} />
        </TabsContent>
      </Tabs>
    </div>
  );
}
